import { render, staticRenderFns } from "./WalletOpenButton.vue?vue&type=template&id=44073c4d&scoped=true"
import script from "./WalletOpenButton.vue?vue&type=script&lang=js"
export * from "./WalletOpenButton.vue?vue&type=script&lang=js"
import style0 from "./WalletOpenButton.vue?vue&type=style&index=0&id=44073c4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44073c4d",
  null
  
)

export default component.exports